import { createReducer, on } from '@ngrx/store';

import { IEjecucionPalanca, IResultProceso } from '../../private/shared/models/task-ejecucion';
import {
    ClearEjecucionIncidencia,
    ClearEjecucionTarea,
    ClearGetEjecucionTarea,
    ClearResultEjecucion,
    errorEjecucionTarea,
    errorGetResultEjecucion,
    errorSendEjecucionIncidencia,
    errorSendEjecucionTarea,
    getEjecucionTarea,
    getResultEjecucion,
    sendEjecucionIncidencia,
    sendEjecucionTarea,
    setTaskCompleted,
    successEjecucionTarea,
    successGetResultEjecucion,
    successSendEjecucionIncidencia,
    successSendEjecucionTarea,
} from '../actions';

/**
 * Obtiene las palancas comerciales, si tiene tarea o no
 */
export interface EjecucionState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    palanca: IEjecucionPalanca[];
}

export const EjecucionInit: EjecucionState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    palanca: [],
};

const _ejecucionReducer = createReducer(EjecucionInit,
    on(getEjecucionTarea, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successEjecucionTarea, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            palanca: data || [],
        }
    )),
    on(setTaskCompleted, (state, { tasks }) => (
        {
            ...state,
            palanca: state.palanca.map(tarea => {
                const index = tasks.findIndex(x => x.ID_Ejecucion_Tarea_Detalle === tarea.ID_Ejecucion_Tarea_Detalle) || 0;
                if (index >= 0) {
                    const task = tasks[index];
                    return ({
                        ...tarea,
                        Check: task.Check,
                        Send: task.Send,
                        Alta: task.Alta,
                        Fotos_Tomadas: task.Fotos_Tomadas,
                    })
                }
                return tarea;
            }),
        }
    )),
    on(errorEjecucionTarea, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(ClearGetEjecucionTarea, state => ({ ...state, ...EjecucionInit })),
);

export function EjecucionReducer(state: any, action: any) {
    return _ejecucionReducer(state, action);
}

/**
 * Envia la tarea de ejecucion
 */
export interface SendEjecucionState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    palanca: IEjecucionPalanca | IEjecucionPalanca[];
    status: string;
}

export const SendEjecucionInit: SendEjecucionState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    palanca: {} as IEjecucionPalanca,
    status: '',
};

const _sendEjecucionReducer = createReducer(SendEjecucionInit,
    on(sendEjecucionTarea, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successSendEjecucionTarea, (state, { data, status }) => (
        {
            ...state,
            loading: false,
            success: true,
            palanca: data,
            status,
        }
    )),
    on(errorSendEjecucionTarea, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(ClearEjecucionTarea, state => ({ ...state, ...SendEjecucionInit })),
);

export function SendEjecucionReducer(state: any, action: any) {
    return _sendEjecucionReducer(state, action);
}

/**
 * Envia comentarios de ejecucion
 */
export interface SendEjecucionInciState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    status: string;
}

export const SendEjecucionInciInit: SendEjecucionInciState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    status: '',
};

const _sendEjecucionInciReducer = createReducer(SendEjecucionInciInit,
    on(sendEjecucionIncidencia, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successSendEjecucionIncidencia, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            status: data.Success,
        }
    )),
    on(errorSendEjecucionIncidencia, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(ClearEjecucionIncidencia, state => ({ ...state, ...SendEjecucionInciInit })),
);

export function SendEjecucionInciReducer(state: any, action: any) {
    return _sendEjecucionInciReducer(state, action);
}

/**
 * Obtiene los resultados de ejecucion
 */
export interface ResultEjecucionState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IResultProceso[];
}

export const ResultEjecucionInit: ResultEjecucionState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: [],
};

const _resultEjecucionReducer = createReducer(ResultEjecucionInit,
    on(getResultEjecucion, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetResultEjecucion, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorGetResultEjecucion, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(ClearResultEjecucion, state => ({ ...state, ...ResultEjecucionInit })),
);

export function ResultEjecucionReducer(state: any, action: any) {
    return _resultEjecucionReducer(state, action);
}
